// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-carousel-container {
  /* margin-top: 6rem; */
}
.carousel .slide img {
  width: 100% !important;
  vertical-align: top !important;
  border: 0;
  margin: auto !important;
  border-radius: 20px !important;
}
.carousel {
  width: 100% !important;
  max-width: 90% !important;
  margin: auto !important;
}
.main-hand-tested-code {
  width: 100% !important;
  max-width: 90% !important;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  border: 1px solid #99a0ac;
  border-radius: 20px;
  background-color: whitesmoke;
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
}
.main-hand-heading {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}
.round-section-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-bottom: 20px;
}
.round-section-box {
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.round-section-image-box {
  width: 50px;
  height: auto;
  display: flex;
  align-items: center;
}
.rount-section-content {
  display: flex;
  align-items: center;
  gap: 6px;
}
.round-section-number {
  font-size: 14px;
  color: #99a0ac;
  font-weight: 500;
}
.round-section-text {
  font-size: 14px;
  line-height: 10px;
  color: #5e676f;
  font-weight: 600;
}
.hottest-main-container {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  padding: 0px 20px;
}
.hottest-main-heading {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}
.hottest-deal-main-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  align-items: center;
  text-align: center;
}
.hottest-picks-containers {
  border: 1px solid #99a0ac;
  padding: 20px 12px 12px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 14px;
  width: 250px;
}
.hottest-picks-image {
  width: 100%;
  height: 170px;
  background-size: cover;
}
.hottest-picks-image-container {
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hottest-picks-off-section {
  background-color: #e84760;
  padding: 4px 10px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
}
.hottest-pickes-deal-heading {
  font-size: 16px;
  font-weight: 600;
  line-height: 12px;
}
.hottest-pickes-deal-contents {
  font-size: 14px;
  line-height: 18px;
  color: #99a0ac;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.hottest-pickes-get-button-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.hottest-picls-get-button {
  background-color: #e84760;
  padding: 6px 14px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/style/carousel.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".banner-carousel-container {\n  /* margin-top: 6rem; */\n}\n.carousel .slide img {\n  width: 100% !important;\n  vertical-align: top !important;\n  border: 0;\n  margin: auto !important;\n  border-radius: 20px !important;\n}\n.carousel {\n  width: 100% !important;\n  max-width: 90% !important;\n  margin: auto !important;\n}\n.main-hand-tested-code {\n  width: 100% !important;\n  max-width: 90% !important;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 50px;\n  border: 1px solid #99a0ac;\n  border-radius: 20px;\n  background-color: whitesmoke;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 30px;\n}\n.main-hand-heading {\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n}\n.round-section-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n.round-section-box {\n  display: flex;\n  flex-direction: column;\n  row-gap: 6px;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n.round-section-image-box {\n  width: 50px;\n  height: auto;\n  display: flex;\n  align-items: center;\n}\n.rount-section-content {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.round-section-number {\n  font-size: 14px;\n  color: #99a0ac;\n  font-weight: 500;\n}\n.round-section-text {\n  font-size: 14px;\n  line-height: 10px;\n  color: #5e676f;\n  font-weight: 600;\n}\n.hottest-main-container {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 50px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 30px;\n  padding: 0px 20px;\n}\n.hottest-main-heading {\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n}\n.hottest-deal-main-section {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  align-items: center;\n  text-align: center;\n}\n.hottest-picks-containers {\n  border: 1px solid #99a0ac;\n  padding: 20px 12px 12px;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 14px;\n  width: 250px;\n}\n.hottest-picks-image {\n  width: 100%;\n  height: 170px;\n  background-size: cover;\n}\n.hottest-picks-image-container {\n  width: 150px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.hottest-picks-off-section {\n  background-color: #e84760;\n  padding: 4px 10px;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.hottest-pickes-deal-heading {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 12px;\n}\n.hottest-pickes-deal-contents {\n  font-size: 14px;\n  line-height: 18px;\n  color: #99a0ac;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n}\n.hottest-pickes-get-button-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.hottest-picls-get-button {\n  background-color: #e84760;\n  padding: 6px 14px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
